import React, { useState } from "react";

const useForm = (initialObj = {}) =>{

    //Se inicializa el valor del form con un objeto vacío
    const [form, setForm] = useState(initialObj);

    //Se setea el valor del form con los nuevos valores
    const changed = ({target}) => {
        const { name, value } = target

    //Setear los campos del form.
        setForm({
            ...form,
            [name]: value
        })
    }

    //Se devuelve el objeto form con la función para actualizar
    return{
        form,
        changed,
    }
};
export default useForm;